import React from "react";
import Cta from "@qlik/qlik/src/components/Cta";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import { getColorClassName } from "@qlik/qlik/src/lib/util/colors";
import * as styles from "./styles.module.css";

/**
 * CTAGreybackground component.
 * Renders a section with a title, description, and CTA buttons.
 * @param {Object} props - The component props.
 * @param {Object} props.data - The data for the section.
 * @param {Object} props.data.cardItem - The card item data.
 * @param {string} props.data.cardItem.title - The title of the section.
 * @param {Object} props.data.cardItem.cta - The CTA buttons for the section.
 */
const CTAGreybackground = ({ data }) => {
    const { additionalConfiguration, backgroundColor, backgroundImage, customId } = data ?? {};

    // Get the spacing class name based on the additional configuration
    const sectionSpacingClassName = getSpacingClassName(additionalConfiguration);
    // Get the color class name based on the background color
    const { sectionColorMapping } = getColorClassName(backgroundColor);

    return (
        <section className={`px-3.75 ${sectionSpacingClassName}`} id={customId}>
            <div className="container">
                <div
                    className={`mr-18 rounded-sm bg-no-repeat bg-center ${
                        styles.bgcontainer
                    } ${sectionColorMapping.bgColor || "bg-stone-light"}`}
                    style={{
                        backgroundImage: `url(${
                            backgroundImage && Array.isArray(backgroundImage)
                                ? backgroundImage[0]?.secure_url.replace("/f_auto", "").replace("/q_auto", "")
                                : null
                        })`,
                    }}
                >
                    <div className="p-8 lg:p-20">
                        <h2
                            className={`title-3 m-auto text-center ${
                                data.backgroundImage === null || data.backgroundImage.length === 0
                                    ? "text-blue"
                                    : "text-white"
                            }`}
                        >
                            {data.cardItem?.title}
                        </h2>
                        <div className="flex gap-y-4 flex-wrap justify-center md:gap-y-5 gap-x-5 mt-7.5">
                            {data?.cardItem?.cta?.map((button) => (
                                <Cta key={button.id} data={button} />
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CTAGreybackground;
